import {
    useCurrentTeamsTagsQuery,
    TagSet,
} from '@precon-tools-suite-by-shared/shared-tags-data-access';
import {
    SortOrder,
    TagOrderByColumn,
} from '@precon-tools-suite-by-shared/precon-graphql-types';
import { OrderMenuItem } from '@precon-tools-suite-by-shared/shared-graphql-client-vue-pagination-ui';
import { computed, ref } from 'vue';

export function useCurrentTeamsTags() {
    // ------------------------------------------------------------------------------------------------------------------ //
    //  OPTIONS                                                                                                           //
    // ------------------------------------------------------------------------------------------------------------------ //

    const rowsPerPageOptions = [10, 20, 50, 100];
    const sortingOptions: Array<OrderMenuItem<'Tag'>> = [
        {
            icon: 'pi pi-sort-alpha-down',
            label: 'Naam oplopend',
            clause: {
                column: TagOrderByColumn.NameFull,
                order: SortOrder.Asc,
            },
        },
        {
            icon: 'pi pi-sort-alpha-down-alt',
            label: 'Naam aflopend',
            clause: {
                column: TagOrderByColumn.NameFull,
                order: SortOrder.Desc,
            },
        },
        {
            icon: 'pi pi-sort-alpha-down',
            label: 'Meest recent bewerkt',
            clause: {
                column: TagOrderByColumn.UpdatedAt,
                order: SortOrder.Asc,
            },
        },
        {
            icon: 'pi pi-sort-alpha-down-alt',
            label: 'Minst recent bewerkt',
            clause: {
                column: TagOrderByColumn.UpdatedAt,
                order: SortOrder.Desc,
            },
        },
    ];

    // ------------------------------------------------------------------------------------------------------------------ //
    //  STATE                                                                                                             //
    // ------------------------------------------------------------------------------------------------------------------ //

    const searchQuery = ref<string>('');
    const sortingOption = ref<OrderMenuItem<'Tag'>>(sortingOptions[0]);
    const first = ref<number>(0);
    const rowsPerPage = ref<number>(rowsPerPageOptions[2]);
    const set = ref<TagSet>('currentTeam');

    const noOfItemsToRetrieve = computed(() => rowsPerPage.value + first.value);

    const sortingClause = computed(() =>
        sortingOption.value
            ? [sortingOption.value.clause]
            : [sortingOptions[0].clause]
    );

    // ------------------------------------------------------------------------------------------------------------------ //
    //  DATA RETRIEVAL                                                                                                    //
    // ------------------------------------------------------------------------------------------------------------------ //

    const query = useCurrentTeamsTagsQuery({
        first: noOfItemsToRetrieve,
        after: '',
        orderBy: sortingClause,
        where: [],
        search: searchQuery,
        set: set,
    });

    const searching = computed(
        () => (searchQuery.value?.length ?? 0) > 0 && query.loading.value
    );

    return {
        rowsPerPageOptions,
        sortingOptions,
        sortingOption,
        first,
        rowsPerPage,
        set,
        searching,
        searchQuery,
        ...query,
    };
}
